import { render, staticRenderFns } from "./AdminGebruikersView.vue?vue&type=template&id=a1425680"
import script from "./AdminGebruikersView.vue?vue&type=script&lang=js"
export * from "./AdminGebruikersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports